import { Icon } from './Icon';

export const DEFAULT_STORE_URL = 'https://titanet.it/store';

/** Store address, configurable at build time with VITE_STORE_URL. */
export function storeUrl(): string {
  const env = import.meta.env?.VITE_STORE_URL as string | undefined;
  return env && env.trim() ? env.trim() : DEFAULT_STORE_URL;
}

/** "Vai allo Store" button in the top-right corner (new tab). Compact ("Store") on narrow screens. */
export function StoreLink() {
  return (
    <a
      className="store-link"
      href={storeUrl()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="store-link"
      aria-label="Vai allo Store (si apre in una nuova scheda)"
      title="Vai allo Store (nuova scheda)"
    >
      <Icon name="store" size={16} />
      <span className="store-link-long">Vai allo Store</span>
      <span className="store-link-short" aria-hidden>
        Store
      </span>
    </a>
  );
}
